export const iconFontAwesomeLogisticsClipboardCheck = (
	<i className="fa-solid fa-clipboard-check"></i>
);
